import { render, staticRenderFns } from "./NoDataYet.vue?vue&type=template&id=00d14127&scoped=true&"
import script from "./NoDataYet.vue?vue&type=script&lang=js&"
export * from "./NoDataYet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00d14127",
  null
  
)

export default component.exports